import React from 'react';
import ReactDOM from 'react-dom';
import * as _ from 'lodash';
import { FIELD_TREE_CONSTRUCTOR_BOX } from './FieldTreeConstructorBoxEvents';
import EventMg from '../utilities/EventManager';
import {
  DropdownMultiSelect,
  DropdownSingleSelect,
} from '../utilities/formComponents';
import { messageUtility } from '../utilities/messageUtility';
import { ArrowDownIcon } from './icons/ArrowDownIcon';

/**
 * 絞り込み検索用マルチセレクト
 */
export class JSDropdownSingleSelect extends React.Component {
  constructor(props) {
    super(props);
    this.component;
    this.dom;
    this.param = {
      name: 'fields',
      laebl: '現場',
      apiurl: 'fields',
    };
    this.setRef = this.setRef.bind(this);
    this.state = {
      enable: true,
      updated: 0,
      isLoading: true, // ロード中フラグ
    };
  }

  instance(component) {
    return new DropdownSingleSelect(component);
  }

  componentDidMount() {
    this.componentInit();
    this.eventBind();
    if (_.has(this.props, 'enable')) {
      this.setState({ enable: this.props.enable });
    }
    if (_.has(this.param, 'apiurl') && this.param.apiurl) {
      this.component.setApiUrl(this.param.apiurl);
    }
    if (_.has(this.param, 'label') && this.param.label) {
      this.component.setLabel(this.param.label);
    }
    setTimeout(() => {
      this.setKey();
    }, 1);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) != JSON.stringify(this.props)) {
      this.component.setProps(nextProps);
      if (_.has(nextProps, 'enable')) {
        this.setState({ enable: nextProps.enable });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', () => {
      this.component.hideDropdown();
    });
  }

  componentInit() {
    /* eslint-disable react/no-find-dom-node */

    this.dom = ReactDOM.findDOMNode(this.myRef);
    /* eslint-enable react/no-find-dom-node */
    this.component = this.instance(this.dom);
    this.component.init();
    this.component.InfinityScrollEnable = this.props.InfinityScrollEnable;
    this.component.setProps(this.props);
    this.component.setCallback((element, name, value, valueName) => {
      if (this.props.callback) {
        this.props.callback(element, name, value, valueName);
      }
    });
  }

  eventBind() {
    EventMg.addEventListener(
      FIELD_TREE_CONSTRUCTOR_BOX.NOW_LOADING,
      isLoading => {
        this.setState({ isLoading });
      }
    );
  }

  setRef(node) {
    this.myRef = node;
  }

  setKey() {}

  resetValue() {
    //初期化
    this.myRef.querySelector('.sys-value-label').innerText = `${
      this.param.label
    }を選択`;
    this.component.clearItems();
    this.myRef.querySelector('.sys-search-input').value = null;
  }

  render() {
    const disabled = () => {
      return !this.state.enable ? { opacity: '.5' } : { opacity: '1' };
    };
    return (
      <div className='form-element__element'>
        <div
          ref={this.setRef}
          className='dropdown-single-select --col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
        >
          <div className='dropdown-single-select__header'>
            <button className='dropdown-select sys-dropdown-trigger --col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'>
              <span
                className='dropdown-select__txt sys-value-label'
                style={disabled()}
              >
                {this.param.label}を選択
              </span>
              <input
                type='hidden'
                name={this.param.name}
                className='sys-value'
                value=''
              />
            </button>
          </div>
          <div className='dropdown dropdown--dropdown-list'>
            <div className='dropdown__item'>
              <div className='dropdown-single-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  className='sys-search-input'
                  placeholder={messageUtility.getMessage('I-000-090')}
                />
              </div>
              <div className='dropdown-single-select__item'>
                <div className='dropdown-single-select__scroll  '>
                  <ul className='single-select' />
                  {this.state.isLoading && <div className='indicator' />}
                  <div className='sys-scroll-anchor' />
                </div>
              </div>
              <div
                className='dropdown-single-select__footer'
                style={{ display: this.props.noSubmit ? 'none' : 'block' }}
              >
                <button className='btn--sm--stay sys-submit'>
                  {messageUtility.getMessage('I-000-091')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * 絞り込み検索用マルチセレクト
 */
export class JSDropdownMultiSelect extends JSDropdownSingleSelect {
  constructor(props) {
    super(props);
    this.component;
    this.param = {
      name: 'company_id',
      label: '',
      limit: 0,
      offset: 0,
      apiurl: 'fields',
    };
    this.setRef = this.setRef.bind(this);
  }

  instance(component) {
    return new DropdownMultiSelect(component);
  }

  displayLabel() {
    return `${this.param.label}を選択`;
  }

  render() {
    const disabled = () => {
      return !this.state.enable ? { opacity: '.5' } : { opacity: '1' };
    };
    const spanSelectAll = { paddingLeft: '5px' };
    return (
      <div className='form-element__element'>
        <div
          ref={this.setRef}
          className='dropdown-multi-select --col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
        >
          <div className='dropdown-multi-select__header'>
            <button className='dropdown-select sys-dropdown-trigger --col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'>
              <span
                className='dropdown-select__txt sys-value-label'
                style={disabled()}
              >
                {this.displayLabel()}
              </span>
              <input
                type='hidden'
                name={this.param.name}
                className='sys-value'
                value=''
              />
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
            </button>
          </div>

          <div className='dropdown dropdown--dropdown-list'>
            <div
              className={`dropdown__item ${
                !_.isUndefined(this.props.widthClass)
                  ? this.props.widthClass
                  : ''
              }`}
            >
              <div className='dropdown-multi-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  className='sys-search-input'
                  placeholder={messageUtility.getMessage('I-000-090')}
                />
              </div>
              <div className='dropdown-multi-select__item'>
                <div className='dropdown-multi-select__checkall'>
                  <div className='btn-checkbox'>
                    <label>
                      <input type='checkbox' className='sys-multi-check' />
                      <i className='i-square-checkbox i-2_5x' />
                    </label>
                  </div>
                  <span style={spanSelectAll}>
                    {messageUtility.getMessage('I-000-092')}
                  </span>
                </div>
              </div>
              <div className='dropdown-multi-select__item'>
                <div className='dropdown-multi-select__scroll  '>
                  <ul className='multi-select' />
                  {this.state.isLoading && <div className='indicator' />}
                  <div className='sys-scroll-anchor' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * フォーム用シングルセレクト
 */
export class JSFormDropdownSingleSelect extends JSDropdownSingleSelect {
  constructor(props) {
    super(props);
    this.component;
    this.param = {
      name: 'company_id',
      label: '',
      apiurl: 'fields',
    };
    this.setRef = this.setRef.bind(this);
    this.alertRef = null;
  }

  render() {
    const disabled = () => {
      return !this.state.enable ? { opacity: '.5' } : { opacity: '1' };
    };
    return (
      <div className='form-list__element'>
        <div
          ref={this.setRef}
          className='dropdown-single-select --col-xs-12 --col-md-12 --col-lg-5 --col-xl-5'
        >
          <div className='dropdown-single-select__header'>
            <button className='dropdown-select sys-dropdown-trigger --col-xl-12 --col-lg-12 --col-md-5 --col-xs-5'>
              <span
                className='dropdown-select__txt sys-value-label'
                style={disabled()}
              >
                {this.param.label}を選択
              </span>
              <input
                type='hidden'
                name={this.param.name}
                className='sys-value'
                value=''
              />
            </button>
          </div>
          <div className='dropdown dropdown--dropdown-list'>
            <div className='dropdown__item'>
              <div className='dropdown-single-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  className='sys-search-input'
                  placeholder={messageUtility.getMessage('I-000-090')}
                />
              </div>
              <div className='dropdown-single-select__item'>
                <div className='dropdown-single-select__scroll  '>
                  <ul className='single-select' />
                  <div className='sys-scroll-anchor' />
                </div>
              </div>
              <div className='dropdown-single-select__footer'>
                <button className='btn--sm--stay sys-submit'>
                  {messageUtility.getMessage('I-000-091')}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          ref={e => {
            this.alertRef = e;
          }}
          className='form-list__alert'
        />
      </div>
    );
  }
}

/**
 * 追加可能なフォーム用のシングルセレクト
 */
export class JSFormDropdownSingleSelectContainer extends JSFormDropdownSingleSelect {
  constructor(props) {
    super(props);
    this.component;
    this.param = {
      name: '',
      label: '',
      apiurl: '',
    };
    this.setRef = this.setRef.bind(this);
    this.state = {
      defaultValue: {},
      enable: true,
    };
    this.index = props.index;
  }

  componentDidMount() {
    super.componentDidMount();
    this.setState({ defaultValue: _.cloneDeep(this.props.defaultValue) });
    setTimeout(() => {
      this.setKey();
    }, 1);
    this.component.setDeleteCallback(() => {
      this.props.onDelete(this.index);
    });
  }

  componentWillReceiveProps(nextProps) {
    super.componentWillReceiveProps(nextProps);
    this.setState({ defaultValue: _.cloneDeep(nextProps.defaultValue) });
    setTimeout(() => {
      this.setKey();
    }, 1);
  }

  GetDeleteButton() {
    if (this.props.deleteButtonShow) {
      return (
        <button className='btn-icon--xs sys-delete'>
          {' '}
          <i className='i-close i-3x' />
        </button>
      );
    } else {
      return <div />;
    }
  }

  render() {
    const disabled = () => {
      return !this.state.enable ? { opacity: '.5' } : { opacity: '1' };
    };
    // eslint-disable-next-line no-unused-vars
    const deleteButton = () => {
      return this.props.deleteButtonShow
        ? { display: 'inline-block' }
        : { display: 'none' };
    };
    return (
      <div className='form-list__element'>
        <div
          ref={this.setRef}
          className='dropdown-single-select --col-xs-12 --col-md-12 --col-lg-5 --col-xl-5'
        >
          <div
            className='dropdown-single-select__header'
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <button className='dropdown-select sys-dropdown-trigger --col-xl-12 --col-lg-12 --col-md-5 --col-xs-5'>
              <span
                className='dropdown-select__txt sys-value-label'
                style={disabled()}
              >
                {this.param.label}を選択
              </span>
              <input
                type='hidden'
                name={this.param.name}
                className='sys-value'
                value=''
              />
            </button>
            {this.GetDeleteButton()}
          </div>
          <div className='dropdown dropdown--dropdown-list'>
            <div className='dropdown__item'>
              <div className='dropdown-single-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  className='sys-search-input'
                  placeholder={messageUtility.getMessage('I-000-090')}
                />
              </div>
              <div className='dropdown-single-select__item'>
                <div className='dropdown-single-select__scroll  '>
                  <ul className='single-select' />
                  <div className='sys-scroll-anchor' />
                </div>
              </div>
              <div className='dropdown-single-select__footer'>
                <button className='btn--sm--stay sys-submit'>
                  {messageUtility.getMessage('I-000-091')}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={e => {
            this.alertRef = e;
          }}
          className='form-list__alert'
        />
      </div>
    );
  }
}

export class JSFormDropdownSingleSelectContainerBlock extends JSFormDropdownSingleSelect {
  constructor(props) {
    super(props);
    this.component;
    this.param = {
      name: '',
      label: '',
      apiurl: '',
    };
    this.setRef = this.setRef.bind(this);
    this.state = {
      defaultValue: {},
      enable: true,
    };
    this.index = props.index;
  }

  componentDidMount() {
    super.componentDidMount();
    this.setState({ defaultValue: _.cloneDeep(this.props.defaultValue) });
    setTimeout(() => {
      this.setKey();
    }, 1);
    this.component.setDeleteCallback(() => {
      this.props.onDelete(this.index);
    });
  }

  componentWillReceiveProps(nextProps) {
    super.componentWillReceiveProps(nextProps);
    this.setState({ defaultValue: _.cloneDeep(nextProps.defaultValue) });
    setTimeout(() => {
      this.setKey();
    }, 1);
  }

  GetDeleteButton() {
    if (this.props.deleteButtonShow) {
      return (
        <button className='btn-icon--xs sys-delete'>
          {' '}
          <i className='i-close i-3x' />
        </button>
      );
    } else {
      return <div />;
    }
  }

  render() {
    const disabled = () => {
      return !this.state.enable ? { opacity: '.5' } : { opacity: '1' };
    };
    // eslint-disable-next-line no-unused-vars
    const deleteButton = () => {
      return this.props.deleteButtonShow
        ? { display: 'inline-block' }
        : { display: 'none' };
    };
    return (
      <div className='form-list__element--block' ref={this.setRef}>
        <div className='dropdown-single-select --col-xs-12 --col-md-12 --col-lg-5 --col-xl-5'>
          <div
            className='dropdown-single-select__header'
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <button className='dropdown-select sys-dropdown-trigger --col-xl-12 --col-lg-12 --col-md-5 --col-xs-5'>
              <span
                className='dropdown-select__txt sys-value-label'
                style={disabled()}
              >
                {this.param.label}を選択
              </span>
              <input
                type='hidden'
                name={this.param.name}
                className='sys-value'
                value=''
              />
            </button>
          </div>
          <div className='dropdown dropdown--dropdown-list'>
            <div className='dropdown__item'>
              <div className='dropdown-single-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  className='sys-search-input'
                  placeholder={messageUtility.getMessage('I-000-090')}
                />
              </div>
              <div className='dropdown-single-select__item'>
                <div className='dropdown-single-select__scroll  '>
                  <ul className='single-select' />
                  <div className='sys-scroll-anchor' />
                </div>
              </div>
              <div className='dropdown-single-select__footer'>
                <button className='btn--sm--stay sys-submit'>
                  {messageUtility.getMessage('I-000-091')}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div style={{ float: 'right' }}>{this.GetDeleteButton()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JSDropdown.jsx